import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AffiliateService } from '../affiliate.service';
import { Constants } from 'src/app/shared/utils/constants';
import Decimal from 'decimal.js';
import { AppService } from 'src/app/app.service';
import { NgForm } from '@angular/forms';
import {forkJoin} from 'rxjs';
import {Router} from '@angular/router';
declare var $: any;
@Component({
  selector: 'fx-ib-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.sass'],
})

export class RankingComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  @ViewChild('modalIBRanking', { static: false }) modalIBRanking: ElementRef;
  constructor(
    private service: AffiliateService,
    private appService:AppService,
    private router: Router) {}

  reward: any;
  listIbRanking = [];
  arr=[
    {
      name: "Bronze",
      rate: null
    },
    {
      name: "Silver",
      rate: null
    },
    {
      name: "Gold",
      rate: null
    },
    {
      name: "Platinum",
      rate: null
    },
    {
      name: "Diamond",
      rate: null
    }
  ];
  showEditTradingVolume = false
  subscription: any = {};
  convertRate = ''; 
  tradingVolume = '0.01';
  errorMessage = ['']
  errorTradingVolume = ''
  
  ngOnInit(): void {
    this.getListIbRanking();
  }

  getListIbRanking(): void {
    this.subscription.getListIbRanking = forkJoin([
      this.service.getListIbRanking(),
      this.service.getTradingVolume(),
    ]).subscribe((res: any) => {
      if (res[0].status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.listIbRanking = res[0].data;
        this.listIbRanking?.map((v) => {
          v.rate = new Decimal(v.rate).mul(100).toString();
          return v;
        });
      }
      if (res[1].status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.convertRate = res[1].data.rate;
        this.tradingVolume =  res[1].data.rate.toString()
      }
    });
  }

  onInput(event: any) {
    if (+event.target.value>100) {
      event.target.value = event.target.value?.slice(1);
    }

  }

  validateRate(){
    for (let index = 0; index < this.arr.length; index++) {
      if (+this.arr[index]?.rate > 100) {
        return true;
      }
    }
  }
  
  setValueIBRanking(): void {
    this.listIbRanking.map((ranking, index)=>{
      this.arr[index] = JSON.parse(JSON.stringify(ranking))
      if(ranking.name == 'Diamond'){
        this.arr[index]['point'] = ranking.from.toString()
      }else{
        this.arr[index]['point'] = ranking.to.toString()
      }
    })
   
  }
 
  onchangePoint(val){
    this.arr[this.arr.length-1]['point'] = (+this.arr[this.arr.length-2]['point']+0.01).toString()
  }

  checkValidPoint(){
    this.errorMessage = [""]
    let checkValid = true
    this.arr.map((d,i)=>{
      let err = ''
      if(i>0){
        if(+d['point'] <= +this.arr[i-1]['point']){
          err = 'Min must be greater than '+this.arr[i-1].name+' required points'
          checkValid = false
        }
        this.errorMessage.push(err)
      }
    })
    return checkValid
  }

  setRequiredPointRange(data){
    data.map((d, i)=>{
      if(d.name == 'Bronze'){
        d.from = 0
        d.to = +d.point
      }else if(d.name != 'Diamond'){
        d.from = (data[i-1].to + 0.01).toFixed(2)
        d.to = +d.point
      }
      if(d.name == 'Diamond'){
        d.from = +d.point
        d.to = d.from + 1
      }
      data[i]= d
    })
    return data
  }

  navigationToPointConversion(){
    this.router.navigate(['/app/affiliate/trading-volumn']); 
  }


  onSubmitIbRanking(){
    if(!this.checkValidPoint()) return
    let data = this.setRequiredPointRange(this.arr);
     data  = JSON.parse(JSON.stringify(this.arr)).map((x) => {
      x.rate=+x.rate;
      if (x.rate === null) {
        x.rate = 0;
      }
      x.rate = (+x.rate/ 100).toFixed(4);
      return x;
    });
    if (!this.form.valid|| this.validateRate()) {
      return;
    }
    this.appService
      .confirm({
        title: `Are you sure that you want to apply?`,
        ok: 'Yes',
        cancel: 'No',
      })
      .subscribe((res) => {
        if (res?.result) {
          this.service.updateIBRanking(data).subscribe((res) => {
            if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
              this.appService.showSuccess('IB Ranking has been apply.');
              this.modalIBRanking.nativeElement.querySelector('button.close').click();
              this.getListIbRanking();
            } else {
              this.appService.showError('IB Ranking fail.');
            }
          });
        }
      });
    
  }

  closeEditIbRanking():void {
    this.errorMessage = ['']
    this.setValueIBRanking()
  }

  saveTradingVolume(){
    if(+this.tradingVolume < 0.01) return
    let params = {
      rate: +this.tradingVolume
    }
    this.subscription.getListIbRanking = this.service.updateTradingVolume(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Update config success');
        this.showEditTradingVolume = false
        this.convertRate = this.tradingVolume
      }
    });
  }

  closeEditTradingVolume(){
    this.showEditTradingVolume = false;
    this.tradingVolume = this.convertRate.toString()
    this.errorMessage = [""]
  }

  ngOnDestroy(): void {
    for (const prop in this.subscription) {
      if (this.subscription[prop]) {
        this.subscription[prop].unsubscribe();
      }
    }
  }
}
